import { render, staticRenderFns } from "./classes.vue?vue&type=template&id=74354afb&scoped=true&"
import script from "./classes.vue?vue&type=script&lang=js&"
export * from "./classes.vue?vue&type=script&lang=js&"
import style0 from "./classes.vue?vue&type=style&index=0&id=74354afb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74354afb",
  null
  
)

export default component.exports